
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexC90y7SG1T2BsIMkVnsLrCEhogkQB5J8_zwakFSGGEdIMeta } from "/app/app/src/pages/index.vue?macro=true";
import { default as index3lyXD9ek6VIdAypKCtAggHJwJ__ENA6y4dwVia235mAMeta } from "/app/app/src/pages/store/index.vue?macro=true";
import { default as printGT8NjLDwAWdZziIV6fZqhvRsuXW274NWg7iEQhrfdpQMeta } from "/app/app/src/pages/store/print.vue?macro=true";
import { default as indexstmPwcgJ1jAt85zyUnwVjMfnJwvKEO6d1tzCHsAgpLQMeta } from "/app/app/src/pages/search/index.vue?macro=true";
import { default as indexNrQfad0c6_JfHL72Jlkkshw4fID8YmzsOTSwR08VIVkMeta } from "/app/app/src/pages/budgets/index.vue?macro=true";
import { default as indexQ9g61zvNI828ztigDDTlsp1TzteUbjVeZaKRBi6PYVEMeta } from "/app/app/src/pages/content/index.vue?macro=true";
import { default as index2IySFmSD6BcGqdNrxHe_B2qnss6T7M6o6BXd_4skN9cMeta } from "/app/app/src/pages/profile/index.vue?macro=true";
import { default as indextTdzb8GnalZ41NYh0X6_L7WzERlzEdNDaZdf_agvKfIMeta } from "/app/app/src/pages/promote/index.vue?macro=true";
import { default as indexlCZfeXR4Xzzg__elXehgflDKahA5BM7TE5XrxHcGpbgMeta } from "/app/app/src/pages/learning/index.vue?macro=true";
import { default as indexuacvsIkYWsC_SneWODYs0M5Q4mrdmT4SwTUWLDEeeBEMeta } from "/app/app/src/pages/planning/index.vue?macro=true";
import { default as indexn_OXoSkeB_ZP_gXuFTRuhOjeH4Llr_yCdokR9aWm0_AMeta } from "/app/app/src/pages/[hubSlug]/index.vue?macro=true";
import { default as indexZdy_DIlK5vK8_F1W_0lwt5HGl7BEFunwd94AIoL6aggMeta } from "/app/app/src/pages/auth/login/index.vue?macro=true";
import { default as indexk_icfvWp0fSYdR38wz3GjapvPZh9Btt64talr8Q91o4Meta } from "/app/app/src/pages/onboarding/index.vue?macro=true";
import { default as indexP_qr4yaQBlyu_Cj3H_JBUPwFwb3aPZbrBdUDYOTkJVcMeta } from "/app/app/src/pages/auth/logout/index.vue?macro=true";
import { default as index22nf5DRubJykSj8NFvJyKth1jt0i4e5lBPFE1eV2qL0Meta } from "/app/app/src/pages/auth/handoff/index.vue?macro=true";
import { default as indexgl0uLLhhARpfaIohgzJIUWG3BqwhWHvvOjUbZGrFKgEMeta } from "/app/app/src/pages/auth/twitter/index.vue?macro=true";
import { default as indexnZFzaslf6F8eB0IHNHtT0i9KE5EJHHPNaLFhwpvhnEEMeta } from "/app/app/src/pages/auth/welcome/index.vue?macro=true";
import { default as indexP5mmnFVoZ_3mL53hbYft2KRuR9gtuHX5P5ud1EForVYMeta } from "/app/app/src/pages/auth/facebook/index.vue?macro=true";
import { default as indexkYZWQpNmOd487X0U9BAEhL9b8qflduvbwljTA08u_q4Meta } from "/app/app/src/pages/auth/linkedin/index.vue?macro=true";
import { default as index0Bb7jxHWwC_Ya_ub2MZCNMdG0Fxv2gb5MWIdYj6BuzEMeta } from "/app/app/src/pages/auth/register/index.vue?macro=true";
import { default as indexoovepY_quEKVJOiXuVio__jbn3rnjLWYbhYwRxTnoBIMeta } from "/app/app/src/pages/auth/instagram/index.vue?macro=true";
import { default as indexLfzdDPNSUtJXSZqnjrSyCosLS_xUjXoBSnD6zAKxI68Meta } from "/app/app/src/pages/oauth2/twitter/index.vue?macro=true";
import { default as indexb1itTREjxFD_j77Q7A5OB6cetT9fFqg2uVTmBU64VHEMeta } from "/app/app/src/pages/store/checkout/index.vue?macro=true";
import { default as indexf_7sJSTg38okeeVbMbCk7QbUzZnCyHwweENxuBQUcMwMeta } from "/app/app/src/pages/welcome-screen/index.vue?macro=true";
import { default as index9OsRO8CoBF1zGw_or6mGzgBBAc2r5LwsTCdmGspcGaAMeta } from "/app/app/src/pages/oauth2/facebook/index.vue?macro=true";
import { default as indexB1uDevV_gQZWEormi7NAv_7MbSI_7mN8T14Mg2If5ksMeta } from "/app/app/src/pages/oauth2/linkedin/index.vue?macro=true";
import { default as indexMB0QfbJzxGd_RYe3a0gmBAfQ3Oc2w7KJmdq9tYIf3bQMeta } from "/app/app/src/pages/content/my-posts/index.vue?macro=true";
import { default as indexoXc4fE9SlofTjxV55ZNHXoEQTYQ5yYdOP4y5BhWuYioMeta } from "/app/app/src/pages/oauth2/instagram/index.vue?macro=true";
import { default as index5Lp2o6ei_GJrRsYIVV6Ca5cTHwEZMJhC0buQE03DkwEMeta } from "/app/app/src/pages/profile/my-posts/index.vue?macro=true";
import { default as index62sALnO3OXY_OqqYJt_as3gONIj5_xSYwpBsueSwX9QMeta } from "/app/app/src/pages/auth/sso/callback/index.vue?macro=true";
import { default as indexHHw5KToABuI6LCIboRTBvMPU4pxVIusF4W9pWZ9eoP8Meta } from "/app/app/src/pages/business-selection/index.vue?macro=true";
import { default as indexIV9ZZL_LqCHEdCkk7rJLx9meZIriWW3H9U8UMeq2a5MMeta } from "/app/app/src/pages/auth/reset-password/index.vue?macro=true";
import { default as indexHDnk5V_l4yImyPYR7cWX_1wE3iCxHV0QQKhdKlfycAIMeta } from "/app/app/src/pages/content/all-content/index.vue?macro=true";
import { default as indexsU_s4L_IleNPDCSaX1Snaf9Nyb0gWipJKVsOIHSDoSEMeta } from "/app/app/src/pages/auth/create-password/index.vue?macro=true";
import { default as indexGlX7OvejaZKbDR952vok8arU62bZmSfXItSI_Aah4IwMeta } from "/app/app/src/pages/profile/certificates/index.vue?macro=true";
import { default as indexQuIE3JAwmaCWtuheHO0sXk6XFCwGkn1TbgJaowwi7HEMeta } from "/app/app/src/pages/auth/register-account/index.vue?macro=true";
import { default as indexzZbf1L5JGePgLRGFuwm7WRTtnS2B1reMD3pR6UKGGF4Meta } from "/app/app/src/pages/auth/set-new-password/index.vue?macro=true";
import { default as indexiMT0ZNvwQmxKslnyO5UdK2zG_l_pj6yl0FoIjZFCiIsMeta } from "/app/app/src/pages/org/[organizationSlug]/index.vue?macro=true";
import { default as index_3C_xY2jKylMWnpiojzao_H2GjCNXJZ89fIgIEH_6pIMeta } from "/app/app/src/pages/[hubSlug]/[contentSlug]/index.vue?macro=true";
import { default as indexgnwD92fQUjaBQ2z_lqArPbCd_TzSD0TiImzgdjyvPToMeta } from "/app/app/src/pages/learning/[curriculumId]/index.vue?macro=true";
import { default as indexuWKFEeG2RM3DXBHr4_rKNT_3LSUHPvL_gRRg_9697OUMeta } from "/app/app/src/pages/profile/change-password/index.vue?macro=true";
import { default as indexkG0sbVjbSDwUfT5Fba9PjyPDwnuoJgXfBGCSB98TiXoMeta } from "/app/app/src/pages/auth/resend-welcome-email/index.vue?macro=true";
import { default as indexKaVLTenHfjDPDUSxFiOUPSGmt52pUzlhRd6ryCvQ5sAMeta } from "/app/app/src/pages/profile/customized-content/index.vue?macro=true";
import { default as indexBgO86xiwuYI_ylmH5cmusJdzXl94YP7XdnE2Ik22vpUMeta } from "/app/app/src/pages/profile/social-connections/index.vue?macro=true";
import { default as termstCAiU6pSctgy3MOD6EOMNsBwkYwr7SeiGtN9uDessiMMeta } from "/app/app/src/pages/onboarding/[onboardingName]/terms.vue?macro=true";
import { default as payment_45step_zRoRFLahMJbmmKOx7iehB1Y6y5h7611qNU46bo4iYoMeta } from "/app/app/src/pages/store/checkout/_steps/payment-step.vue?macro=true";
import { default as indexfyT6lwD1cVs9rnL2ByanCLwy2YMHmmkWjC_cIB2ShOgMeta } from "/app/app/src/pages/content/all-content/[hubSlug]/index.vue?macro=true";
import { default as indexTJ2KkOP2Z3XK5VqPSgINXGuQZxOdytkz9QGRdCa3ZaIMeta } from "/app/app/src/pages/learning/modules/[moduleSlug]/index.vue?macro=true";
import { default as delivery_45stepzczHT5oYdKP00ZcZFWwL_j7kSdwZP_Nt0Rn8SvTqK6YMeta } from "/app/app/src/pages/store/checkout/_steps/delivery-step.vue?macro=true";
import { default as shipping_45stepgcZcQm5XUzEnCecpm8hPFb6caQ_y00aqCadKex7ttW0Meta } from "/app/app/src/pages/store/checkout/_steps/shipping-step.vue?macro=true";
import { default as playerhpbgFaMGL9_H_vM4k_06inZTfyWV2PvYCY410gKMT3IMeta } from "/app/app/src/pages/learning/modules/[moduleSlug]/player.vue?macro=true";
import { default as index3M4ifNmeJIS6xqfw9zbHOnFLdqCPWoRvUXbe7nK7E9IMeta } from "/app/app/src/pages/org/[organizationSlug]/[hubSlug]/index.vue?macro=true";
import { default as indexy_T5462Oib20TaFryx3ZVn42MIaYAUuQSJJRcLnyqDoMeta } from "/app/app/src/pages/content/all-content/[hubSlug]/[contentSlug]/index.vue?macro=true";
import { default as indexodJ_od8UBCURBDmX2dGmVXpPVpAr8pJhgNi0p66Tb90Meta } from "/app/app/src/pages/learning/[curriculumId]/modules/[moduleSlug]/index.vue?macro=true";
import { default as playerLwQAOeM4RxlCFHkzUsOTARAyi8lzZUGblXx9_GVRx0cMeta } from "/app/app/src/pages/learning/[curriculumId]/modules/[moduleSlug]/player.vue?macro=true";
import { default as indexXsX0Y1GTB9zw4JUXpWOw57enYIWKGoRK0NxUHS_v2bgMeta } from "/app/app/src/pages/org/[organizationSlug]/[hubSlug]/[contentSlug]/index.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexC90y7SG1T2BsIMkVnsLrCEhogkQB5J8_zwakFSGGEdIMeta || {},
    component: () => import("/app/app/src/pages/index.vue")
  },
  {
    name: "store",
    path: "/store",
    meta: index3lyXD9ek6VIdAypKCtAggHJwJ__ENA6y4dwVia235mAMeta || {},
    component: () => import("/app/app/src/pages/store/index.vue")
  },
  {
    name: "store-print",
    path: "/store/print",
    meta: printGT8NjLDwAWdZziIV6fZqhvRsuXW274NWg7iEQhrfdpQMeta || {},
    component: () => import("/app/app/src/pages/store/print.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexstmPwcgJ1jAt85zyUnwVjMfnJwvKEO6d1tzCHsAgpLQMeta || {},
    alias: ["/search/shared"],
    component: () => import("/app/app/src/pages/search/index.vue")
  },
  {
    name: "budgets",
    path: "/budgets",
    meta: indexNrQfad0c6_JfHL72Jlkkshw4fID8YmzsOTSwR08VIVkMeta || {},
    component: () => import("/app/app/src/pages/budgets/index.vue")
  },
  {
    name: "content",
    path: "/content",
    meta: indexQ9g61zvNI828ztigDDTlsp1TzteUbjVeZaKRBi6PYVEMeta || {},
    component: () => import("/app/app/src/pages/content/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: index2IySFmSD6BcGqdNrxHe_B2qnss6T7M6o6BXd_4skN9cMeta || {},
    component: () => import("/app/app/src/pages/profile/index.vue")
  },
  {
    name: "promote",
    path: "/promote",
    meta: indextTdzb8GnalZ41NYh0X6_L7WzERlzEdNDaZdf_agvKfIMeta || {},
    component: () => import("/app/app/src/pages/promote/index.vue")
  },
  {
    name: "learning",
    path: "/learning",
    meta: indexlCZfeXR4Xzzg__elXehgflDKahA5BM7TE5XrxHcGpbgMeta || {},
    component: () => import("/app/app/src/pages/learning/index.vue")
  },
  {
    name: "planning",
    path: "/planning",
    component: () => import("/app/app/src/pages/planning/index.vue")
  },
  {
    name: "hubSlug",
    path: "/:hubSlug()",
    meta: indexn_OXoSkeB_ZP_gXuFTRuhOjeH4Llr_yCdokR9aWm0_AMeta || {},
    component: () => import("/app/app/src/pages/[hubSlug]/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexZdy_DIlK5vK8_F1W_0lwt5HGl7BEFunwd94AIoL6aggMeta || {},
    component: () => import("/app/app/src/pages/auth/login/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: indexk_icfvWp0fSYdR38wz3GjapvPZh9Btt64talr8Q91o4Meta || {},
    component: () => import("/app/app/src/pages/onboarding/index.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: indexP_qr4yaQBlyu_Cj3H_JBUPwFwb3aPZbrBdUDYOTkJVcMeta || {},
    component: () => import("/app/app/src/pages/auth/logout/index.vue")
  },
  {
    name: "auth-handoff",
    path: "/auth/handoff",
    meta: index22nf5DRubJykSj8NFvJyKth1jt0i4e5lBPFE1eV2qL0Meta || {},
    component: () => import("/app/app/src/pages/auth/handoff/index.vue")
  },
  {
    name: "auth-twitter",
    path: "/auth/twitter",
    meta: indexgl0uLLhhARpfaIohgzJIUWG3BqwhWHvvOjUbZGrFKgEMeta || {},
    component: () => import("/app/app/src/pages/auth/twitter/index.vue")
  },
  {
    name: "auth-welcome",
    path: "/auth/welcome",
    meta: indexnZFzaslf6F8eB0IHNHtT0i9KE5EJHHPNaLFhwpvhnEEMeta || {},
    component: () => import("/app/app/src/pages/auth/welcome/index.vue")
  },
  {
    name: "auth-facebook",
    path: "/auth/facebook",
    meta: indexP5mmnFVoZ_3mL53hbYft2KRuR9gtuHX5P5ud1EForVYMeta || {},
    component: () => import("/app/app/src/pages/auth/facebook/index.vue")
  },
  {
    name: "auth-linkedin",
    path: "/auth/linkedin",
    meta: indexkYZWQpNmOd487X0U9BAEhL9b8qflduvbwljTA08u_q4Meta || {},
    component: () => import("/app/app/src/pages/auth/linkedin/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: index0Bb7jxHWwC_Ya_ub2MZCNMdG0Fxv2gb5MWIdYj6BuzEMeta || {},
    component: () => import("/app/app/src/pages/auth/register/index.vue")
  },
  {
    name: "auth-instagram",
    path: "/auth/instagram",
    meta: indexoovepY_quEKVJOiXuVio__jbn3rnjLWYbhYwRxTnoBIMeta || {},
    component: () => import("/app/app/src/pages/auth/instagram/index.vue")
  },
  {
    name: "oauth2-twitter",
    path: "/oauth2/twitter",
    meta: indexLfzdDPNSUtJXSZqnjrSyCosLS_xUjXoBSnD6zAKxI68Meta || {},
    component: () => import("/app/app/src/pages/oauth2/twitter/index.vue")
  },
  {
    name: "store-checkout",
    path: "/store/checkout",
    meta: indexb1itTREjxFD_j77Q7A5OB6cetT9fFqg2uVTmBU64VHEMeta || {},
    component: () => import("/app/app/src/pages/store/checkout/index.vue")
  },
  {
    name: "welcome-screen",
    path: "/welcome-screen",
    meta: indexf_7sJSTg38okeeVbMbCk7QbUzZnCyHwweENxuBQUcMwMeta || {},
    component: () => import("/app/app/src/pages/welcome-screen/index.vue")
  },
  {
    name: "oauth2-facebook",
    path: "/oauth2/facebook",
    meta: index9OsRO8CoBF1zGw_or6mGzgBBAc2r5LwsTCdmGspcGaAMeta || {},
    component: () => import("/app/app/src/pages/oauth2/facebook/index.vue")
  },
  {
    name: "oauth2-linkedin",
    path: "/oauth2/linkedin",
    meta: indexB1uDevV_gQZWEormi7NAv_7MbSI_7mN8T14Mg2If5ksMeta || {},
    component: () => import("/app/app/src/pages/oauth2/linkedin/index.vue")
  },
  {
    name: "content-my-posts",
    path: "/content/my-posts",
    meta: indexMB0QfbJzxGd_RYe3a0gmBAfQ3Oc2w7KJmdq9tYIf3bQMeta || {},
    component: () => import("/app/app/src/pages/content/my-posts/index.vue")
  },
  {
    name: "oauth2-instagram",
    path: "/oauth2/instagram",
    meta: indexoXc4fE9SlofTjxV55ZNHXoEQTYQ5yYdOP4y5BhWuYioMeta || {},
    component: () => import("/app/app/src/pages/oauth2/instagram/index.vue")
  },
  {
    name: "profile-my-posts",
    path: "/profile/my-posts",
    meta: index5Lp2o6ei_GJrRsYIVV6Ca5cTHwEZMJhC0buQE03DkwEMeta || {},
    component: () => import("/app/app/src/pages/profile/my-posts/index.vue")
  },
  {
    name: "auth-sso-callback",
    path: "/auth/sso/callback",
    meta: index62sALnO3OXY_OqqYJt_as3gONIj5_xSYwpBsueSwX9QMeta || {},
    component: () => import("/app/app/src/pages/auth/sso/callback/index.vue")
  },
  {
    name: "business-selection",
    path: "/business-selection",
    meta: indexHHw5KToABuI6LCIboRTBvMPU4pxVIusF4W9pWZ9eoP8Meta || {},
    component: () => import("/app/app/src/pages/business-selection/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: indexIV9ZZL_LqCHEdCkk7rJLx9meZIriWW3H9U8UMeq2a5MMeta || {},
    component: () => import("/app/app/src/pages/auth/reset-password/index.vue")
  },
  {
    name: "content-all-content",
    path: "/content/all-content",
    component: () => import("/app/app/src/pages/content/all-content/index.vue")
  },
  {
    name: "auth-create-password",
    path: "/auth/create-password",
    meta: indexsU_s4L_IleNPDCSaX1Snaf9Nyb0gWipJKVsOIHSDoSEMeta || {},
    component: () => import("/app/app/src/pages/auth/create-password/index.vue")
  },
  {
    name: "profile-certificates",
    path: "/profile/certificates",
    meta: indexGlX7OvejaZKbDR952vok8arU62bZmSfXItSI_Aah4IwMeta || {},
    component: () => import("/app/app/src/pages/profile/certificates/index.vue")
  },
  {
    name: "auth-register-account",
    path: "/auth/register-account",
    meta: indexQuIE3JAwmaCWtuheHO0sXk6XFCwGkn1TbgJaowwi7HEMeta || {},
    component: () => import("/app/app/src/pages/auth/register-account/index.vue")
  },
  {
    name: "auth-set-new-password",
    path: "/auth/set-new-password",
    meta: indexzZbf1L5JGePgLRGFuwm7WRTtnS2B1reMD3pR6UKGGF4Meta || {},
    component: () => import("/app/app/src/pages/auth/set-new-password/index.vue")
  },
  {
    name: "org-organizationSlug",
    path: "/org/:organizationSlug()",
    meta: indexiMT0ZNvwQmxKslnyO5UdK2zG_l_pj6yl0FoIjZFCiIsMeta || {},
    component: () => import("/app/app/src/pages/org/[organizationSlug]/index.vue")
  },
  {
    name: "hubSlug-contentSlug",
    path: "/:hubSlug()/:contentSlug()",
    props: true,
    component: () => import("/app/app/src/pages/[hubSlug]/[contentSlug]/index.vue")
  },
  {
    name: "learning-curriculumId",
    path: "/learning/:curriculumId()",
    meta: indexgnwD92fQUjaBQ2z_lqArPbCd_TzSD0TiImzgdjyvPToMeta || {},
    component: () => import("/app/app/src/pages/learning/[curriculumId]/index.vue")
  },
  {
    name: "profile-change-password",
    path: "/profile/change-password",
    meta: indexuWKFEeG2RM3DXBHr4_rKNT_3LSUHPvL_gRRg_9697OUMeta || {},
    component: () => import("/app/app/src/pages/profile/change-password/index.vue")
  },
  {
    name: "auth-resend-welcome-email",
    path: "/auth/resend-welcome-email",
    meta: indexkG0sbVjbSDwUfT5Fba9PjyPDwnuoJgXfBGCSB98TiXoMeta || {},
    component: () => import("/app/app/src/pages/auth/resend-welcome-email/index.vue")
  },
  {
    name: "profile-customized-content",
    path: "/profile/customized-content",
    meta: indexKaVLTenHfjDPDUSxFiOUPSGmt52pUzlhRd6ryCvQ5sAMeta || {},
    component: () => import("/app/app/src/pages/profile/customized-content/index.vue")
  },
  {
    name: "profile-social-connections",
    path: "/profile/social-connections",
    meta: indexBgO86xiwuYI_ylmH5cmusJdzXl94YP7XdnE2Ik22vpUMeta || {},
    component: () => import("/app/app/src/pages/profile/social-connections/index.vue")
  },
  {
    name: "onboarding-onboardingName-terms",
    path: "/onboarding/:onboardingName()/terms",
    meta: termstCAiU6pSctgy3MOD6EOMNsBwkYwr7SeiGtN9uDessiMMeta || {},
    component: () => import("/app/app/src/pages/onboarding/[onboardingName]/terms.vue")
  },
  {
    name: "store-checkout-_steps-payment-step",
    path: "/store/checkout/_steps/payment-step",
    component: () => import("/app/app/src/pages/store/checkout/_steps/payment-step.vue")
  },
  {
    name: "content-all-content-hubSlug",
    path: "/content/all-content/:hubSlug()",
    meta: indexfyT6lwD1cVs9rnL2ByanCLwy2YMHmmkWjC_cIB2ShOgMeta || {},
    component: () => import("/app/app/src/pages/content/all-content/[hubSlug]/index.vue")
  },
  {
    name: "learning-modules-moduleSlug",
    path: "/learning/modules/:moduleSlug()",
    meta: indexTJ2KkOP2Z3XK5VqPSgINXGuQZxOdytkz9QGRdCa3ZaIMeta || {},
    component: () => import("/app/app/src/pages/learning/modules/[moduleSlug]/index.vue")
  },
  {
    name: "store-checkout-_steps-delivery-step",
    path: "/store/checkout/_steps/delivery-step",
    component: () => import("/app/app/src/pages/store/checkout/_steps/delivery-step.vue")
  },
  {
    name: "store-checkout-_steps-shipping-step",
    path: "/store/checkout/_steps/shipping-step",
    component: () => import("/app/app/src/pages/store/checkout/_steps/shipping-step.vue")
  },
  {
    name: "learning-modules-moduleSlug-player",
    path: "/learning/modules/:moduleSlug()/player",
    meta: playerhpbgFaMGL9_H_vM4k_06inZTfyWV2PvYCY410gKMT3IMeta || {},
    component: () => import("/app/app/src/pages/learning/modules/[moduleSlug]/player.vue")
  },
  {
    name: "org-organizationSlug-hubSlug",
    path: "/org/:organizationSlug()/:hubSlug()",
    meta: index3M4ifNmeJIS6xqfw9zbHOnFLdqCPWoRvUXbe7nK7E9IMeta || {},
    component: () => import("/app/app/src/pages/org/[organizationSlug]/[hubSlug]/index.vue")
  },
  {
    name: "content-all-content-hubSlug-contentSlug",
    path: "/content/all-content/:hubSlug()/:contentSlug()",
    props: true,
    component: () => import("/app/app/src/pages/content/all-content/[hubSlug]/[contentSlug]/index.vue")
  },
  {
    name: "learning-curriculumId-modules-moduleSlug",
    path: "/learning/:curriculumId()/modules/:moduleSlug()",
    meta: indexodJ_od8UBCURBDmX2dGmVXpPVpAr8pJhgNi0p66Tb90Meta || {},
    component: () => import("/app/app/src/pages/learning/[curriculumId]/modules/[moduleSlug]/index.vue")
  },
  {
    name: "learning-curriculumId-modules-moduleSlug-player",
    path: "/learning/:curriculumId()/modules/:moduleSlug()/player",
    meta: playerLwQAOeM4RxlCFHkzUsOTARAyi8lzZUGblXx9_GVRx0cMeta || {},
    component: () => import("/app/app/src/pages/learning/[curriculumId]/modules/[moduleSlug]/player.vue")
  },
  {
    name: "org-organizationSlug-hubSlug-contentSlug",
    path: "/org/:organizationSlug()/:hubSlug()/:contentSlug()",
    meta: indexXsX0Y1GTB9zw4JUXpWOw57enYIWKGoRK0NxUHS_v2bgMeta || {},
    component: () => import("/app/app/src/pages/org/[organizationSlug]/[hubSlug]/[contentSlug]/index.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/my-customized-content",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/all-content",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/my-personalized-content",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/content/my-personalized-content",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/my-posts",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/content/hubs",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/print",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/checkout",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]